// extracted by mini-css-extract-plugin
export var childrenContainer = "_8o-0";